import BasicRouterView from "../../components/BasicRouterView.vue";

const ferramentariaRoutes = {
  path: "frm",
  redirect: { name: "ferramentaria-catalogo" },
  meta: {
    label: "Ferramentaria",
    icon: "plumbing",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "ferramentaria/catalogo-ferramenta",
      name: "ferramentaria-catalogo",
      meta: {
        label: "Catálogo de Ferramentas",
        icon: "store",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "frm" */ "./views/CatalogoFerramenta.vue"),
    },
    {
      path: "ferramentaria/catalogo-ativo",
      name: "ferramentaria-catalogo-ativo",
      meta: {
        label: "Lista de Ativos",
        icon: "storefront",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "frm" */ "./views/CatalogoAtivo.vue"),
    },
    {
      path: "ferramentaria/catalogo-ativo-externo",
      name: "ferramentaria-catalogo-ativo-externo",
      meta: {
        label: "Lista de Ativos Externos",
        icon: "repartition",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/CatalogoAtivoExterno.vue"
        ),
    },
    {
      path: "ferramentaria/gerenciamento-regras",
      name: "gerenciamento-regras",
      meta: {
        label: "Gerenciamento de Regras",
        icon: "repartition",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "frm" */ "./views/GerenciamentoRegras.vue"),
    },
    {
      path: "ferramentaria/catalogo-ativo-deletado",
      name: "ferramentaria-catalogo-ativo-deletado",
      meta: {
        label: "Lista de Ativos Deletados",
        icon: "delete",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/CatalogoAtivoDeletado.vue"
        ),
    },
    {
      path: "ferramentaria/retirada-ferramenta",
      name: "ferramentaria-retirada-ferramenta",
      meta: {
        label: "Retirada",
        icon: "build",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "frm" */ "./views/RetirarFerramenta.vue"),
    },
    {
      path: "ferramentaria/retirada-ferramenta-permanencia",
      name: "ferramentaria-retirada-ferramenta-permanencia",
      meta: {
        label: "Retirada Permanencia",
        icon: "build",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/RetirarFerramentaTempoPermanencia.vue"
        ),
    },
    {
      path: "ferramentaria/relatorio-medicao/:id?",
      name: "ferramentaria-relatorio-medicao",
      meta: {
        label: "Relatório Medição",
        icon: "build",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "frm" */ "./views/RelatorioMedicao.vue"),
    },
    {
      path: "ferramentaria/vinculo-ativo-documento/:ativoUuid/:tipoAtivo/:unidadeId?",
      name: "ferramentaria-vinculo-ativo-documento",
      meta: {
        label: "Retirada",
        icon: "build",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/VinculoAtivoDocumento.vue"
        ),
    },
    {
      path: "ferramentaria/devolver-ferramenta",
      name: "ferramentaria-devolver-ferramenta",
      meta: {
        label: "Devolução",
        icon: "arrow_right_alt",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "frm" */ "./views/DevolverFerramenta.vue"),
    },
    {
      path: "ferramentaria/lista-reserva",
      name: "ferramentaria-lista-reserva",
      meta: {
        label: "Reserva",
        icon: "schedule",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "frm" */ "./views/ListaReserva.vue"),
    },
    {
      path: "ferramentaria/reserva-ferramenta/:id?",
      name: "ferramentaria-reserva-ferramenta",
      meta: {
        label: "Reserva",
        icon: "schedule",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "frm" */ "./views/ReservaFerramentas.vue"),
    },
    {
      path: "ferramentaria/detalhe-reserva/:reservaId",
      name: "ferramentaria-detalhe-reserva",
      meta: {
        label: "Reserva",
        icon: "schedule",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "frm" */ "./views/DetalheReserva.vue"),
    },
    {
      path: "ferramentaria/cadastro-ferramenta-catalogo",
      name: "ferramentaria-cadastro-catalogo",
      meta: {
        label: "Criar Nova Ferramenta no Catálogo",
        icon: "store",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/CriarFerramentaCatalogo.vue"
        ),
    },
    {
      path: "ferramentaria/cadastro-grupo-ferramenta",
      name: "ferramentaria-cadastro-grupo",
      meta: {
        label: "Grupo",
        icon: "group_add",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/CadastrarGrupoFerramenta.vue"
        ),
    },
    {
      path: "ferramentaria/detalhe-grupo-ferramenta/:grupoId",
      name: "ferramentaria-detalhe-grupo",
      meta: {
        label: "",
        icon: "group_add",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "frm" */ "./views/DetalheGrupo.vue"),
    },
    {
      path: "ferramentaria/recebimento",
      name: "ferramentaria-recebimento",
      meta: {
        label: "Recebimento",
        icon: "call_received",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "frm" */ "./views/Recebimento.vue"),
    },
    {
      path: "ferramentaria/recebimento-entrada-requisicao",
      name: "ferramentaria-recebimento-entrada-requisicao",
      meta: {
        label: "Recebimento",
        icon: "call_received",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/RecebimentoRequisicao.vue"
        ),
    },
    {
      path: "ferramentaria/transferencia-interna",
      name: "ferramentaria-transferencia-interna",
      meta: {
        label: "Transferência Interna",
        icon: "move_up",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/ListaTransferenciaInterna.vue"
        ),
    },
    {
      path: "ferramentaria/detalhe-transferencia-interna/:transferenciaId",
      name: "ferramentaria-detalhe-transferencia-interna",
      meta: {
        label: "Transferência Interna",
        icon: "transfer_within_a_station",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/DetalheTransferenciaInterna.vue"
        ),
    },
    {
      path: "ferramentaria/transferencia-impressao-romaneio-interna/:transferenciaId",
      name: "ferramentaria-transferencia-impressao-romaneio-interna",
      meta: {
        label: "Transferência Interna",
        icon: "transfer_within_a_station",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/ImpressaoTransferenciaInterna.vue"
        ),
    },
    {
      path: "ferramentaria/transferencia-impressao-romaneio-interna-simplificada/:transferenciaId",
      name: "ferramentaria-transferencia-impressao-romaneio-interna-simplificada",
      meta: {
        label: "Transferência Interna",
        icon: "transfer_within_a_station",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/ImpressaoTransferenciaInternaSimplificada.vue"
        ),
    },
    {
      path: "ferramentaria/transferencia-impressao-romaneio-externa/:transferenciaId",
      name: "ferramentaria-transferencia-impressao-romaneio-externa",
      meta: {
        label: "Transferência Externa",
        icon: "transfer_within_a_station",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/ImpressaoTransferenciaExterna.vue"
        ),
    },
    {
      path: "ferramentaria/transferencia-externa",
      name: "ferramentaria-transferencia-externa",
      meta: {
        label: "Transferência Externa",
        icon: "move_down",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/ListaTransferenciaExterna.vue"
        ),
    },
    {
      path: "ferramentaria/detalhe-transferencia-externa/:transferenciaId",
      name: "ferramentaria-detalhe-transferencia-externa",
      meta: {
        label: "Transferência Externa",
        icon: "transfer_within_a_station",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/DetalheTransferenciaExterna.vue"
        ),
    },
    {
      path: "ferramentaria/criar-ferramenta-catalogo",
      name: "ferramentaria-criar-ferramenta-catalogo",
      meta: {
        label: "Criar Ferramenta Catálogo",
        icon: "move_up",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/CriarFerramentaEstoque.vue"
        ),
    },
    {
      path: "ferramentaria/movimentar-status-ferramenta",
      name: "ferramentaria-movimentar-status-ferramenta",
      meta: {
        label: "Movimentar Status",
        icon: "sync_alt",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "frm" */ "./views/MovimentarStatus.vue"),
    },
    {
      path: "ferramentaria/movimentar-status-ferramenta-externo",
      name: "ferramentaria-movimentar-status-ferramenta-externo",
      meta: {
        label: "Movimentar Status Externo",
        icon: "sync_alt",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/MovimentarStatusAtivoExterno.vue"
        ),
    },
    {
      path: "ferramentaria/detalhe-movimentacao/:ferramentaId",
      name: "ferramentaria-detalhe-movimentacao",
      meta: {
        label: "Criar Ferramenta Estoque",
        icon: "move_up",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/DetalheMovimentacaoStatus.vue"
        ),
    },
    {
      path: "ferramentaria/historico-ativo/:ativoUuid/:tipoAtivo",
      name: "ferramentaria-historico-ativo",
      meta: {
        label: "Criar Ferramenta Estoque",
        icon: "move_up",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/HistoricoMovimentacaoAtivo.vue"
        ),
    },
    {
      path: "ferramentaria/ficha-cautela/:id?",
      name: "ferramentaria-ficha-cautela",
      meta: {
        label: "Relatório Cautela",
        icon: "fact_check",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "frm" */ "./views/RelatorioCautela.vue"),
    },
    {
      path: "ferramentaria/impressao-cautela/:dados",
      name: "ferramentaria-impressao-cautela",
      meta: {
        label: "Cautela",
        icon: "fact_check",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "frm" */ "./views/ImpressaoCautela.vue"),
    },
    {
      path: "ferramentaria/configurar-ficha-cautela",
      name: "ferramentaria-configurar-ficha-cautela",
      meta: {
        label: "Customização de Ficha Cautela",
        icon: "badge",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/ConfiguracaoFichaCautela.vue"
        ),
    },
    {
      path: "ferramentaria/configuracao-setup/:catalogoUuid",
      name: "ferramentaria-configuracao-setup",
      meta: {
        label: "Configuração Setup",
        icon: "badge",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "frm" */ "./views/SetupCatalogo.vue"),
    },
    {
      path: "ferramentaria/configuracao",
      name: "ferramentaria-configuracao",
      redirect: { name: "ferramentaria-configuracao-status" },
      meta: {
        label: "Configurações",
        icon: "settings",

        show: true,
      },
      children: [
        {
          path: "status/:id?",
          name: "ferramentaria-configuracao-status",
          meta: {
            label: "Criar Ferramenta Estoque",

            icon: "move_up",
            show: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "frm" */ "./components/ConfiguracaoStatus.vue"
            ),
        },
        {
          path: "operacao/:id?",
          name: "ferramentaria-configuracao-operacao",
          meta: {
            label: "Criar Ferramenta Estoque",
            icon: "move_up",

            show: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "frm" */ "./components/ConfiguracaoOperacao.vue"
            ),
        },
        {
          path: "catalogo/:id?",
          name: "ferramentaria-configuracao-catalogo",
          meta: {
            label: "Ferramentaria Configuração",
            icon: "move_up",

            show: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "frm" */ "./components/ConfiguracaoCatalogoFerramenta.vue"
            ),
        },
        {
          path: "checklist/:id?",
          name: "ferramentaria-configuracao-checklist",
          meta: {
            label: "Criar Ferramenta Estoque",
            icon: "move_up",

            show: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "frm" */ "./components/ConfiguracaoChecklist.vue"
            ),
        },
        {
          path: "deposito/:id?",
          name: "ferramentaria-configuracao-deposito",
          meta: {
            label: "",
            icon: "move_up",

            show: false,
          },
          component: () =>
            import(
              /* webpackChunkName: "frm" */ "./components/ConfiguracaoDeposito.vue"
            ),
        },
      ],

      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/ConfiguracaoFerramentaria.vue"
        ),
    },
    {
      path: "ferramentaria/relatorio-catalogo/:id?",
      name: "ferramentaria-relatorio-catalogo",
      meta: {
        label: "Relatório Catálogo",
        icon: "description",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "frm" */ "./views/RelatorioCatalogo.vue"),
    },
    {
      path: "ferramentaria/relatorio-ativos/:id?",
      name: "ferramentaria-relatorio-ativos",
      meta: {
        label: "Relatório Ativos",
        icon: "construction",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "frm" */ "./views/RelatorioAtivos.vue"),
    },
    {
      path: "ferramentaria/relatorio-ativos-simplificado/:id?",
      name: "ferramentaria-relatorio-ativos-simplificado",
      meta: {
        label: "Relatório Ativos Simplificado",
        icon: "handyman",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/RelatorioAtivosSimplificado.vue"
        ),
    },
    {
      path: "ferramentaria/relatorio-emprestimo/:id?",
      name: "ferramentaria-relatorio-emprestimo",
      meta: {
        label: "Relatório Empréstimo",
        icon: "build_circle",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "frm" */ "./views/RelatorioEmprestimo.vue"),
    },
    {
      path: "ferramentaria/relatorio-movimentacao/:id?",
      name: "ferramentaria-relatorio-movimentacao",
      meta: {
        label: "Relatório Movimentação",
        icon: "compare_arrows",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/RelatorioMovimentacao.vue"
        ),
    },
    {
      path: "ferramentaria/relatorio-catalogo-simplificado/:id?",
      name: "ferramentaria-relatorio-catalogo-simplificado",
      meta: {
        label: "Relatório Cátalago Simplificado",
        icon: "summarize",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/RelatorioCatalogoAtivo.vue"
        ),
    },
    {
      path: "ferramentaria/relatorio-ativo-externo/:id?",
      name: "ferramentaria-relatorio-ativo-externo",
      meta: {
        label: "Relatório Ativos Externos",
        icon: "domain",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/RelatorioAtivosExternos.vue"
        ),
    },
    {
      path: "ferramentaria/relatorio-checklist-acessorio/:id?",
      name: "ferramentaria-relatorio-checklist-acessorio",
      meta: {
        label: "Relatório Respostas Acessórios/Checklists",
        icon: "domain",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/RelatorioAcessorioChecklist.vue"
        ),
    },
    {
      path: "ferramentaria/relatorio-status-manual/:id?",
      name: "ferramentaria-relatorio-status-manual",
      meta: {
        label: "Relatório de Movimentações de Status Manual",
        icon: "domain",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/RelatorioStatusManual.vue"
        ),
    },
    {
      path: "ferramentaria/configuracao-alertas",
      name: "ferramentaria-configuracao-alertas",
      meta: {
        label: "Configuração Alertas",
        icon: "notifications",

        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "frm" */ "./views/ConfiguracaoAletas.vue"),
    },
    {
      path: "ferramentaria/logs-setup",
      name: "ferramentaria-logs-setup",
      meta: {
        label: "Logs Setup",
        icon: "notifications",

        show: true,
      },
      component: () => import(/* webpackChunkName: "frm" */ "./views/Logs.vue"),
    },
    {
      path: "ferramentaria/logs-setup-detalhe/:id",
      name: "ferramentaria-logs-setup-detalhe",
      meta: {
        label: "Logs Setup",
        icon: "notifications",

        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "frm" */ "./views/LogsSetupDetalhe.vue"),
    },
    {
      path: "ferramentaria/criacao-ativos-massa/",
      name: "ferramentaria-criacao-ativos-massa",
      meta: {
        label: "Criação Ativos em Massa",
        icon: "create",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "frm" */ "./views/CriacaoAtivosEmMassa.vue"
        ),
    },
  ],
};

export default ferramentariaRoutes;
